import React from 'react'
import CvTemplate from '../CvTemplate'

const CvEnMain = () => {
	return (
		<CvTemplate
			name="Recu Daniel"
			age={33}
			city="București"
			phone="+40 748 702 852"
			email="recudaniel@yahoo.com"
			website="https://webackit.com"
			linkedin="https://www.linkedin.com/in/daniel-recu"
			github="https://github.com/recuDaniel"
			// aboutMe="I help companies automate workflows, scale WordPress platforms, and optimize SaaS delivery - combining 12+ years of coding, AI automation, and infrastructure experience. Specialist in WordPress custom architecture, React.js applications, Python automation, AI integrations, and DevOps."
			aboutMe="Experienced Digital Solutions Architect and Founder, specializing in advanced WordPress architecture, React.js development, AI-driven automation, and DevOps infrastructure. Created 200+ automation solutions and 50+ custom WordPress plugins."
			strengths={[
				'Custom WordPress architecture (themes, 50+ plugins, Gutenberg blocks)',
				'Advanced automation tools (browser, Python, SikuliX, AI integrations)',
				'AI-driven implementations (Ollama, Mistral, GPT-4)',
				'Robust DevOps strategies (Docker, CI/CD, AWS, DigitalOcean, Nginx)',
				'Won multiple design contests on 99designs.com for creative, high-quality visual work.'
			]}
			skillsData={[
				{
					category: 'Frontend',
					skills: 'React.js, Gutenberg blocks, Custom WordPress Themes, HTML5, CSS3, JavaScript, TypeScript'
				},
				{
					category: 'Backend',
					skills: 'PHP, Python, Node.js, SQL, WooCommerce, REST API'
				},
				{
					category: 'DevOps & Infrastructure',
					skills: 'Docker, GitHub Actions, Nginx, AWS (EC2, S3), DigitalOcean, Linux Administration'
				},
				{
					category: 'Database',
					skills: 'MySQL, MariaDB, Redis'
				},
				{
					category: 'AI & Automation',
					skills: 'GPT-4, Ollama, Mistral, Python Automation, SikuliX, Selenium, Binance API trading bot'
				},
				{
					category: 'Design & SEO',
					skills: 'Adobe Creative Suite, Figma, SEO Optimization, Speed Optimization'
				}
			]}
			projects={[
				{
					title: 'On-Subscription SaaS Platform',
					description:
						'Created a subscription-based service management platform with React dashboards, WordPress backend, custom CRM, and automation integrations.'
				},
				{
					title: 'WordPress Custom Framework',
					description:
						'Built a fully custom WordPress theme and 50+ Gutenberg blocks utilizing React.js components for enhanced content management and interactivity.'
				},
				{
					title: 'Advanced WordPress Plugin Suite',
					description:
						'Developed over 50 specialized plugins ranging from SEO, security, automation, analytics, user management, and content optimization.'
				},
				{
					title: 'Complex Browser-Based Automation',
					description:
						'Built an advanced Python-controlled automation tool integrated with Chrome extensions and SikuliX for tasks on 200+ websites.'
				},
				{
					title: 'AI Agent with Ollama-Mistral',
					description:
						'Developed an intelligent database assistant capable of real-time interactions, database operations, and decision-making based on Mistral AI.'
				},
				{
					title: 'Binance Trading Bot',
					description:
						'Engineered a Python-based automated trading bot ensuring safe, gradual investment strategies via Binance API.'
				}
			]}
			workHistory={[
				{
					title: 'Digital Solutions Architect & Founder',
					company: 'Webackit Solutions S.R.L.',
					period: 'July 2021 - Present',
					description: `
  <p><strong>Founder and Solutions Architect</strong> at <em>Webackit Solutions S.R.L.</em>, delivering cutting-edge digital products across diverse industries with a strong focus on <strong>automation-first architecture, performance, and scalability</strong>.</p>

  <p><strong>Key Projects & Contributions:</strong></p>
  <ul>
    <li>
      <strong>On-Subscription.com</strong> – A fully custom B2B SaaS platform built with <strong>React.js</strong> and <strong>MobX</strong>, featuring:
      <ul>
        <li>Complex subscription lifecycle & client portal management</li>
        <li>Secure external API integrations and real-time dashboard views</li>
        <li>Mobile-first modular UI using <strong>TailwindCSS</strong> & <em>CSS-in-JS</em></li>
      </ul>
    </li>
    <li>
      <strong>200+ automation tools</strong> built with <strong>Python</strong>, Chrome extensions & <em>SikuliX</em>:
      <ul>
        <li>Automated content posting, account creation, scraping, and data entry</li>
        <li>Rule-based browser automation agent capable of visual element recognition</li>
        <li>Next-gen version powered by <strong>Ollama + Mistral</strong> LLM agent</li>
      </ul>
    </li>
    <li>
      <strong>WordPress Plugin Ecosystem</strong> – Developed 50+ plugins covering:
      <ul>
        <li>Security, SEO, GDPR compliance, user management, and analytics</li>
        <li>Custom post types, REST/GraphQL endpoints, and WebSocket sync</li>
        <li>Gutenberg-compatible components with React.js interactivity</li>
      </ul>
    </li>
    <li>
      Built backend microservices and APIs using <strong>Node.js</strong>, <strong>PHP</strong>, <strong>Python</strong> and <strong>GraphQL</strong> to handle:
      <ul>
        <li>Real-time data pipelines, AI triggers (e.g., OpenAI, Ollama), and automation tasks</li>
        <li>Scraping infrastructure for competitive analysis and internal data enrichment</li>
      </ul>
    </li>
    <li>
      Managed full <strong>DevOps lifecycle</strong>:
      <ul>
        <li>Provisioned <strong>AWS EC2, RDS, S3</strong> via <em>Terraform & CloudFormation</em></li>
        <li>Dockerized all services for production parity and CI/CD stability</li>
        <li>Zero-downtime deployments via <strong>GitHub Actions, GitLab CI</strong>, and <strong>Bitbucket Pipelines</strong></li>
      </ul>
    </li>
    <li>
      Led Agile sprints via <strong>Jira</strong> and maintained project documentation in <strong>Confluence</strong>. Applied Git strategies with rigorous code reviews and PR workflows using <strong>GitHub</strong> and <strong>GitLab</strong>.
    </li>
  </ul>

  <p><strong>Impact:</strong> Reduced operational overhead by <strong>40%</strong> through modular platform design, automation pipelines, and efficient infrastructure practices. Delivered 50+ tailored WordPress client solutions with rapid feature deployment.</p>
`,
					techStack:
						'React.js, MobX, TailwindCSS, CSS-in-JS, Node.js, PHP, Python, GraphQL, REST API, WordPress, Gutenberg, Docker, AWS (EC2, RDS, S3), CloudFormation, Terraform, GitHub Actions, GitLab CI, Bitbucket Pipelines, MySQL, MariaDB, Redis, SikuliX, Selenium, Ollama, Mistral, GPT-4, Adobe Creative Suite, Jira, Confluence'
				},
				{
					title: 'Senior React Developer',
					company: 'iNoRisk GmbH & Co. KG',
					period: 'Jan 2022 - Apr 2025',
					description: `
  <p><strong>Senior React Developer</strong> at <em>iNoRisk GmbH & Co. KG</em>, focusing on building enterprise-grade financial systems with an emphasis on performance, maintainability, and modular architecture.</p>

  <p><strong>Key Responsibilities & Achievements:</strong></p>
  <ul>
    <li>
      <strong>MobX Architecture:</strong>
      <ul>
        <li>Led full migration to <strong>MobX</strong>, improving state responsiveness and cutting unnecessary re-renders by <strong>~70%</strong>.</li>
        <li>Structured domain-level stores, actions, and computed values to streamline scalability and testing.</li>
      </ul>
    </li>
    <li>
      <strong>Frontend Architecture:</strong>
      <ul>
        <li>Introduced a modular folder structure to boost code reusability and team maintainability.</li>
        <li>Refactored legacy code using <code>React.memo</code>, selectors, and MobX observers for performance isolation.</li>
        <li>Reduced feature delivery time by <strong>~40%</strong> through reusable UI components and layout patterns.</li>
      </ul>
    </li>
    <li>
      <strong>Design Implementation:</strong>
      <ul>
        <li>Used <strong>TailwindCSS</strong> to deliver fully responsive, cross-platform UI experiences.</li>
        <li>Maintained design consistency by modularizing utility-first styling patterns.</li>
      </ul>
    </li>
    <li>
      <strong>Cross-Team Collaboration:</strong>
      <ul>
        <li>Worked closely with backend teams to define and enforce clean API contracts.</li>
        <li>Led frontend planning during <em>SCRUM ceremonies</em>, offering architectural insight and support.</li>
      </ul>
    </li>
    <li>
      <strong>Testing & Optimization:</strong>
      <ul>
        <li>Implemented test coverage with <strong>Jest</strong> and <strong>React Testing Library</strong>, ensuring robust components.</li>
        <li>Applied <em>code splitting</em>, <em>dynamic imports</em>, and <em>debouncing</em> to optimize UX.</li>
        <li>Achieved a <strong>60% reduction</strong> in app load time via render path profiling and optimization.</li>
      </ul>
    </li>
    <li>
      <strong>CI/CD & Deployment:</strong>
      <ul>
        <li>Managed GitHub Actions pipelines for automated testing and deployment workflows.</li>
        <li>Ensured stable, low-downtime releases via versioned deployments and rollback strategies.</li>
      </ul>
    </li>
	<li>
	  <strong>PostgreSQL Expertise:</strong>
	  <ul>
		<li>Utilized PostgreSQL in production for over 3 years, handling complex queries, data modeling, and performance optimization for large-scale datasets.</li>
		<li>Implemented advanced indexing strategies and query optimizations to enhance data retrieval speeds.</li>
	  </ul>
	</li>
  </ul>
`,
					techStack:
						'React.js, MobX, TailwindCSS, GitHub Actions, Jest, React Testing Library'
				},
				{
					title: 'Senior Software Developer',
					company: 'Extendstudio',
					period: 'Jan 2022 - Mar 2023',
					description: `
  <p><strong>Senior Software Developer</strong> at <em>Extendstudio</em>, focused on architecting complex WordPress plugin systems and modern React-based interfaces to elevate admin experience and plugin performance.</p>

  <p><strong>Key Responsibilities & Contributions:</strong></p>
  <ul>
    <li>
      <strong>React-Based Admin Panels:</strong>
      <ul>
        <li>Developed scalable UI components with <strong>React.js</strong>, enabling dynamic plugin settings panels, layout editors, and interactive config interfaces.</li>
        <li>Utilized <em>React Hooks</em>, <em>Context API</em>, and <em>CSS-in-JS</em> to power fast, state-driven interfaces with consistent styling and responsiveness.</li>
      </ul>
    </li>
    <li>
      <strong>Reusable Form System:</strong>
      <ul>
        <li>Designed a flexible, reusable form engine with <strong>nested field support</strong>, <em>conditional logic</em>, and <em>real-time validation</em>.</li>
        <li>Enabled faster prototyping of plugin interfaces with reduced technical debt.</li>
      </ul>
    </li>
    <li>
      <strong>Data Layer & Separation of Concerns:</strong>
      <ul>
        <li>Built an internal data-fetching abstraction to simplify WordPress REST API usage within plugins.</li>
        <li>Minimized logic duplication and enabled smoother backend/frontend decoupling.</li>
      </ul>
    </li>
    <li>
      <strong>Team Collaboration:</strong>
      <ul>
        <li>Worked directly with backend engineers, product owners, and designers to tightly align plugin UX and functionality.</li>
        <li>Delivered polished, <em>app-like WordPress interfaces</em> with seamless REST API integrations.</li>
      </ul>
    </li>
  </ul>

  <p><strong>Result:</strong> Played a pivotal role in delivering several production-ready WordPress plugins with highly modular, performant admin interfaces—contributing significantly to UI architecture standards within the company.</p>
`,
					techStack:
						'WordPress, React.js, PHP, Gutenberg Blocks, REST API, React Hooks, CSS-in-JS'
				},
				{
					title: 'Senior Software Developer',
					company: 'TPC Management SRL',
					period: 'Apr 2019 - May 2021',
					description: `
  <p><strong>Senior Full-Stack Developer</strong> at <em>TPC Management SRL</em>, delivering mobile and web applications, custom WordPress solutions, and high-performance digital assets for both internal projects and clients across multiple industries.</p>

  <p><strong>Key Responsibilities & Projects:</strong></p>
  <ul>
    <li>
      <strong>Mobile Development:</strong>
      <ul>
        <li>Inherited and completed a <strong>React Native</strong> health education app for deployment in third-world countries.</li>
        <li>Used <strong>Expo</strong> to streamline builds for Android and iOS.</li>
        <li>Implemented offline support, push notifications, local storage sync, and custom native modules.</li>
        <li>Performed memory profiling and UI debugging to improve load time and responsiveness.</li>
      </ul>
    </li>
    <li>
      <strong>WordPress Integration & Web Development:</strong>
      <ul>
        <li>Built REST APIs to sync React Native apps with WordPress backends using secure auth and real-time models.</li>
        <li>Designed flexible SQL schemas for <em>media syncing, user activity tracking, and live content delivery</em>.</li>
        <li>Delivered fully custom WordPress websites with tailored themes for various industries.</li>
      </ul>
    </li>
    <li>
      <strong>SEO & Performance:</strong>
      <ul>
        <li>Led advanced SEO strategies: keyword research, structured data implementation, and technical audits.</li>
        <li>Improved organic traffic and search rankings across several company-owned and client websites.</li>
      </ul>
    </li>
    <li>
      <strong>Cross-Platform Optimization:</strong>
      <ul>
        <li>Developed reusable shared logic for API validation and error handling.</li>
        <li>Reduced redundant development by ~50% through reusable modules and shared libraries.</li>
        <li>Implemented background sync and debounced UI logic to reduce latency.</li>
      </ul>
    </li>
    <li>
      <strong>Design & Branding:</strong>
      <ul>
        <li>Produced all marketing visuals including <em>banners, flyers, billboards, and brochures</em> using Adobe Suite.</li>
      </ul>
    </li>
    <li>
      <strong>Team Collaboration:</strong>
      <ul>
        <li>Coordinated across frontend, backend, and marketing teams under agile methodologies.</li>
        <li>Delivered high-quality results under tight deadlines while ensuring consistency and scalability.</li>
      </ul>
    </li>
  </ul>
`,
					techStack:
						'React Native, React.js, Expo, WordPress, PHP, REST API, JavaScript, TypeScript, SQL, Adobe Photoshop, Adobe Illustrator, SEO optimization'
				},
				{
					title: 'Web Developer',
					company: 'LtvStudio',
					period: 'Feb 2016 - Nov 2018',
					description: `
  <p><strong>Web Developer</strong> at <em>LtvStudio</em>, focused on delivering responsive, modern WordPress websites with high visual appeal and optimized frontend performance.</p>

  <p><strong>Main Responsibilities & Accomplishments:</strong></p>
  <ul>
    <li>
      <strong>Responsive Theme Development:</strong>
      <ul>
        <li>Created custom WordPress themes using <strong>HTML5</strong> semantic layouts and <strong>advanced CSS3</strong> techniques.</li>
        <li>Utilized <em>media queries, flexbox, transitions, and grid</em> for optimal responsiveness across devices and browsers.</li>
      </ul>
    </li>
    <li>
      <strong>Interactive Frontend Features:</strong>
      <ul>
        <li>Enhanced UX with custom <strong>JavaScript</strong> components and dynamic UI behavior.</li>
        <li>Integrated WordPress APIs for real-time content rendering and user-driven interactions.</li>
      </ul>
    </li>
    <li>
      <strong>Performance & Compatibility:</strong>
      <ul>
        <li>Conducted in-depth <em>performance optimization</em> and cross-browser compatibility testing.</li>
        <li>Refined JavaScript and CSS for better load times and seamless rendering across platforms.</li>
      </ul>
    </li>
    <li>
      <strong>Plugin & Theme Customization:</strong>
      <ul>
        <li>Customized WordPress plugins and themes to align with project-specific UI/UX needs.</li>
        <li>Extended existing functionality through JS enhancements and semantic HTML structures.</li>
      </ul>
    </li>
    <li>
      <strong>Library Integration & Enhancement:</strong>
      <ul>
        <li>Integrated third-party JavaScript libraries to add animation, sliders, modals, and interactivity.</li>
        <li>Boosted engagement and interactivity without compromising performance or stability.</li>
      </ul>
    </li>
    <li>
      <strong>Project Delivery:</strong>
      <ul>
        <li>Managed complete web development lifecycles from brief to launch.</li>
        <li>Ensured high-quality execution, meeting deadlines and client expectations consistently.</li>
      </ul>
    </li>
  </ul>
`,
					techStack:
						'WordPress, HTML5, CSS3, JavaScript, Responsive Design, CSS Animations, Cross-Browser Compatibility'
				},
				{
					title: 'Web Designer & Developer',
					company: 'Metropolitan Residence',
					period: 'May 2015 - Feb 2016',
					description: `
    <p><strong>Web Designer & Developer</strong> responsible for building modern marketing websites to promote residential real estate projects.</p>
    <ul>
      <li>Developed and maintained custom <strong>WordPress</strong> themes using <em>PHP, HTML5, and CSS3</em>.</li>
      <li>Implemented responsive design and optimized layouts for mobile and tablet views.</li>
      <li>Created digital visual assets using <strong>Adobe Photoshop</strong> and <strong>Illustrator</strong> for banners, brochures, and site media.</li>
    </ul>
  `,
					techStack:
						'WordPress, PHP, HTML5, CSS3, Adobe Creative Suite'
				},
				{
					title: 'Marketing & SEO Assistant',
					company: 'ROPLAST INSTAL DISTRIBUTION',
					period: 'Mar 2014 - Apr 2015',
					description: `
    <p><strong>SEO & Digital Marketing Assistant</strong> focused on improving the company’s online presence and technical SEO foundation.</p>
    <ul>
      <li>Performed on-page SEO audits and optimized <strong>WordPress</strong> site structure for crawlability and ranking.</li>
      <li>Improved page speed and reduced bounce rates by optimizing <em>HTML & CSS delivery</em>.</li>
      <li>Worked alongside marketing team to refine digital content strategy and enhance visibility.</li>
    </ul>
  `,
					techStack: 'WordPress, HTML, CSS, SEO tools'
				}
			]}
			education={[
				{
					title: 'MSc Computer Science with AI',
					institution: 'Keele University, UK',
					period: '2023 - 2025 (in progress)',
					details:
						'Machine learning (SVM, decision trees), Jupyter/Pandas, AI ethics, automation systems. Personal Binance Python bot project.'
				},
				{
					title: 'Certified Web Designer',
					institution: 'Link Academy',
					period: '2013 - 2014',
					details: 'HTML, CSS, JS, PHP, Adobe Suite.'
				},
				{
					title: 'Arts High School (Nicolae Tonitza)',
					institution: 'Bucharest',
					period: '2007 - 2011',
					details: 'Visual arts, design thinking.'
				}
			]}
			languages={['Romanian (native)', 'English (advanced)']}
			availability={['Full-time', 'Project-based', 'Remote']}
			sectionsMarginTop={{
				about: 30,
				strengths: 15,
				skills: 10,
				workHistory: 0,
				education: 0
			}}
		/>
	)
}

export default CvEnMain
